import React from 'react';
import Hero from './Hero/FinanceCalculatorHero';
import MainSection from './MainSection/FinanceCalculatorMainSection';

const FinanceCalculator = ({ fields }) => {
  // 映射数据到各个部分
  const hero = {
    title: fields.title?.value || '',
    description: fields.description?.value || '',
  };

  const carList = fields.list || [];

  return (
    <div className="container">
      <Hero title={hero.title} description={hero.description} />
      <MainSection data={carList} />
    </div>
  );
};

export default FinanceCalculator;
